export default {
    currentFlowId: null,
    service: '',
    unassigned: [],
    priorized: [],
    notifyPrecedentPriorities: false,
    roundRobin: false,
};
